import React, { FC } from 'react';

import { useFormContext } from 'react-hook-form';

import { roundedHoursOptions } from 'utils/selectOptionsUtils';

import Input from 'components/Input/Input';
import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

interface IHourFieldProps {
  isSuperAdmin: boolean;
  startHour: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  hasError: boolean;
  errorMessage: string;
  selectedOption: { value: string; label: string } | undefined;
  onSelectChange: (value: string) => void;
}

const HourField: FC<IHourFieldProps> = ({
  isSuperAdmin,
  startHour,
  onInputChange,
  onBlur,
  hasError,
  errorMessage,
  selectedOption,
  onSelectChange
}): React.ReactElement => {
  const form = useFormContext();
  const startHourError = form.formState.errors.startHour;
  const startHourTouched = form.formState.touchedFields.startHour;

  if (isSuperAdmin) {
    return (
      <div className="space-y-2">
        <Input
          label="Hour (UTC)"
          isRequired
          name="startHour"
          type="time"
          className="w-[100px]"
          value={startHour}
          onChange={onInputChange}
          onBlur={onBlur}
          state={hasError ? 'error' : 'default'}
          description={hasError ? errorMessage : ''}
        />
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="w-[100px]">
        <InputSelectDropdown
          label="* Hour (UTC)"
          options={roundedHoursOptions}
          defaultSelected={selectedOption}
          onOptionChange={onSelectChange}
        />
      </div>
      {startHourTouched && startHourError && (
        <p className="text-sm text-red-500">
          {String(startHourError.message || '')}
        </p>
      )}
    </div>
  );
};

export { HourField };
